// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { CircularProgress } from '@mui/material';
import Flex from '@shared/components/Flex';
import Button from '@shared/components/Button';

import { FunctionType } from '@modules/Private/submodules/DataManagement';

export interface PreparingProps {
  className?: string;
  onCancel: () => any;
  functionType: FunctionType;
}

class Preparing extends React.Component<PreparingProps> {
  render() {
    const { onCancel, functionType } = this.props;
    const classes = withStyles.getClasses(this.props);

    const str = functionType === FunctionType.import ? "The CSV file is being imported" : "The Excel file is being created";

    return (
      <Flex className={classes.root} alignItems="center" justifyContent="center" direction="column">
        <Flex alignItems="center">
          <CircularProgress size={20} />
          <h1 className={classes.heading}>{str}. This operation may take a few minutes.</h1>
        </Flex>
        <h6 className={classes.subheading}>Please don't leave the page until the process completes.</h6>
        <Button size="small" variant="outlined" text="Cancel" onClick={onCancel} />
      </Flex>
    );
  }
}

const PreparingStyled = withStyles(
  Preparing, 
  (theme, props) => ({
    "root": {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: 'rgba(255, 255, 255, .9)',
      zIndex: 1
    },
    "heading": {
      fontSize: 35,
      marginLeft: theme.spacing(4)
    },
    "subheading": {
      fontWeight: 500,
      fontSize: 19,
      color: theme.palette.colors.grey,
      margin: theme.spacing(0, 0, 4)
    }
  })
);

export default PreparingStyled;